import { FormProvider } from 'react-hook-form';

export const TEST_SUBMIT_BUTTON_ID = 'test-submit-button';

export const FormTestWrapper = ({
  children,
  onSubmit = (_data) => _data,
  formMethods,
}) => {
  return (
    <FormProvider {...formMethods}>
      {children}
      <button
        data-testid={TEST_SUBMIT_BUTTON_ID}
        type="submit"
        onClick={formMethods.handleSubmit((data) => onSubmit(data))}
      >
        Submit
      </button>
    </FormProvider>
  );
};
